// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__3WWOs","mover":"slider_mover__2hOGO","draggable":"slider_draggable__1JUzj","prev":"slider_prev__3U4GA","next":"slider_next__tBMGW"};